<template>
    <svg class="svg-icon" aria-hidden="true">
        <use :xlink:href="symbolId" rel="external nofollow" />
    </svg>
</template>

<script setup name="svg-icon">
import { computed } from "vue";
const props = defineProps({
    name: {
        type: String,
        required: true,
    },
});
let symbolId = computed(() => {
    return `#icon-${props.name}`;
});
</script>

<style lang="scss">
.svg-icon {
    width: 1em;
    height: 1em;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
}
</style>
